import { useAppsStore } from "@/pinia/appsStore";
import { usePromptStore } from "@/pinia/promptStore";
import { useUserStore } from "@/pinia/userStore";
import { computed } from "vue";

export const useRecentActivity = () => {
  const appsStore = useAppsStore();
  const promptStore = usePromptStore();
  const userStore = useUserStore();

  const demoFlagOn = computed(() => !!appsStore?.app?.flags?.demo);

  const updatePathActivity = (appId, pathId) => {
    if (!userStore.currUser) return;
    if (userStore.isCurrentSuperAdmin && !demoFlagOn.value) return;

    const timestamp = parseInt(new Date() / 1000); // epoch time in seconds
    promptStore.updateRecentPathActivity({
      appId,
      pathId,
      userId: userStore.currUser.id,
      timestamp,
    });
  };

  return { demoFlagOn, updatePathActivity };
};
